// src/store/manifestThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

export const createManifestDetails = createAsyncThunk('data/createManifestDetails', 
    async(data)=>{
        const res = await axiosInstance.post('/api/v1/CreateMenifestDetails', data);
        return res.data
    }
  )

// export const getManifestList = createAsyncThunk(
//   'data/getManifestList',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await axiosInstance.get(`/api/v1/menifestbyofficeid/${data.OfficeId}`);
//       console.log("Manifest response", res.data);
//       return res.data;
//     } catch (error) {
//       console.error("Manifest API error:", error.response?.data || error.message);
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// getAdminManifestList
 export const getManifestList = createAsyncThunk('data/getManifestList',
    async(data)=>{
      const res = await axiosInstance.get(`/api/v1/getMenifestDetails?page=${data.page}&limit=${data.limit}&search=${data.search}&OfficeId=${data.OfficeId}&pending=${data.pending}`);
      return res.data
    }
  )
export const createDriverDetails = createAsyncThunk('data/createDriverDetails', 
    async(data)=>{
        const res = await axiosInstance.post('/api/v1/CreateDriverDetails', data);
        return res.data
    }
)

// src/Thunk/officeManifestThunk.js
export const getDriverDetails = createAsyncThunk(
    'data/getDriverDetails',
    async () => {
      const res = await axiosInstance.get('/api/v1/getAllDriverDetails');
      return res.data;
    }
  );
  
  export const deleteMenifestDetails = createAsyncThunk('data/deleteMenifestDetails',
    async(data)=>{
      console.log(data);
      const res = await axiosInstance.delete(`/api/v1/deleteMenifestDetails/${data}`);
        return res.data
      }
  )
  export const getPickupListThunk = createAsyncThunk(
    'data/getPickupListThunk',
    async () => {
      const res = await axiosInstance.get('/api/v1/getPickupDetails');
      return res.data;
    }
  );
  export const updateManifestDetails = createAsyncThunk('data/updateManifestDetails',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/updateMenifestDetails', data);
      return res.data
  }
)
export const updateMDocketDetails = createAsyncThunk('data/updateMDocketDetails',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/docket/updateDocket', data);
      return res.data
  }
)



export const fetchAndOpenPdf = createAsyncThunk(
  "pdf/fetchAndOpen",
  async (ManifestId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/v1/getSingleMenifestDetails/${ManifestId}`);
      const pdfUrl = response?.data?.pdfUrl;

      if (pdfUrl) {
        window.open(pdfUrl, "_blank"); // ✅ open in new tab
        return pdfUrl;
      } else {
        return rejectWithValue("PDF URL not found");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Something went wrong");
    }
  }
);

